import { useEffect, useState, useRef } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import { Table, Badge, Flex, Typography, Input, Space, Button } from "antd";
import { useTable} from "@refinedev/antd";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useInvalidate } from "@refinedev/core";
import { SearchOutlined } from '@ant-design/icons';
import { useFormatter } from "@/hooks/useFormatter";

const { TextArea } = Input;
const handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
};
const getColumnSearchProps = (dataIndex, searchInput) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
    <div
      style={{
        padding: 8,
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Input
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        style={{
          marginBottom: 8,
          display: 'block',
        }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
          }}
        >
          Search
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          close
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined
      style={{
        color: filtered ? '#1677ff' : undefined,
      }}
    />
  ),
 // onFilter: (value, record) =>
 //   record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => searchInput.current?.select(), 100);
    }
  },

});

export const MaintenancesPanel = ({type}) => {
  const { state, dispatch } = useResourceContext();
  const [ selectedInstance ] = state.selectedResources;

  return selectedInstance?<MaintenancesTab key={selectedInstance.id} selectedId={selectedInstance.id} type={type}/>:null;
}
const MaintenancesTab = ({type, selectedId}) => {
  const { formatDateTime } = useFormatter();
  const invalidate = useInvalidate();
  const totalRef = useRef(0);
  const searchInput = useRef(null);
  const { tableProps} = useTable({
    resource:"maintenances",
    syncWithLocation: false,
    filters: {initial: [
      {field: "subject",operator:"contains"},
      {field: "reason",operator:"contains"},
      {field: "start_time",operator:"contains"},
      {field: "end_time",operator:"contains"},
      {field: "active",operator:"eq"},
    ]},
    pagination:{current:1, pageSize:10},
    sorters: {initial: []},
    meta:{id:selectedId, type:type, _total_:totalRef.current}
  });
  const { Title } = Typography;
  totalRef.current = tableProps.pagination.total || totalRef.current;
  let title = `Maintenance (${totalRef.current})`;
  const columns = [
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
      ...getColumnSearchProps('subject',searchInput)
    },   
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
      ...getColumnSearchProps('reason',searchInput)
    },
    {
      title: 'Start Time',
      dataIndex: 'start_time',
      render: (value) => formatDateTime(value),
      key: 'start_time',
      ...getColumnSearchProps('start_time',searchInput)
    },   
    {
      title: 'End Time',
      dataIndex: 'end_time',
      render: (value) => formatDateTime(value),
      key: 'end_time',
      ...getColumnSearchProps('end_time',searchInput)
    },   
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',
      ...getColumnSearchProps('active',searchInput)
    }
  ];
  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={5} >{title}</Title>
        <RefreshButton onClick={() => {
          invalidate({
            resource: "events",
            invalidates: ["list"],
          });
        }}/>
      </Flex> 
      <div style={{paddingTop:"10px"}}>    
      <Table {...tableProps} rowKey="id" size="small" columns= {columns} />
      </div>
    </div>
  );
}